import * as XLSX from "xlsx";

export const exportToExcel = (jsonData, fileName = "report") => {
  // 1. Kreiranje worksheet-a iz JSON-a
  const worksheet = XLSX.utils.json_to_sheet(jsonData);

  // 2. Kreiranje workbook-a
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  // 3. Export fajla
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
